"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _vuex = require("vuex");
var _booking = require("@/api/bookSpace/booking");
var _DragDialog = _interopRequireDefault(require("@/components/DragDialog"));
var _utils = require("@/utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "",
  components: {
    dragDialog: _DragDialog.default
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    disabledType: {
      type: Boolean,
      default: false
    },
    bookingHeadWebId: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      fileList: [],
      headers: {
        "Content-Type": "multipart/form-data"
      }
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language', 'userInfo'])),
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    uploadFile: function uploadFile(item) {
      var _this = this;
      this.loading = (0, _utils.load)();
      var formDatas = new FormData();
      formDatas.append("file", item.file);
      (0, _booking.excelImportDocument)(formDatas).then(function (res) {
        if (res.success) {
          _this.$message.success(_this.$t("com.importSuccess"));
          _this.$parent.handleSearch();
        } else {
          _this.$message.warning(res.errorMessages[0]);
        }
      }).finally(function () {
        _this.loading.close();
        _this.fileList = [];
        _this.$refs.upload.clearFiles();
      });
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      console.log('this.fileId', file);
      var isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 10MB!');
      }
      this.fileList.push(file);
      return isLt2M;
    },
    handleDownloadExcelKR: function handleDownloadExcelKR() {
      var link = document.createElement('a');
      link.href = '/static/excel/Document_Import_Format.xls'; // 指向你的 Word 文档路径
      link.download = 'Document_Import_Format.xls'; // 设置下载文件名
      link.click(); // 触发点击事件
    },
    handleUploadFile: function handleUploadFile() {
      console.log('this.fileId', this.fileList);
      if (this.$refs.upload.uploadFiles.length === 0) {
        return this.$message.warning(this.$t("home.selectFileWaring"));
      }
      this.$refs.upload.submit();
    },
    opened: function opened() {
      //   this.handleSearch()
      console.log('opened');
    }
  }
};